(function () {
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    "use strict";
    function Game(initialState) {
        var _this = this;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.score = 0;
        this.status = "idle";
        this.board = initialState ? initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        }) : Array.from({
            length: this.size
        }, function() {
            return Array(_this.size).fill(0);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "createBoard",
            value: function createBoard() {
                var _this = this;
                return Array.from({
                    length: this.size
                }, function() {
                    return Array(_this.size).fill(0);
                });
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var moved = this.move(function(row) {
                    return row;
                }, function(row) {
                    return row.reverse();
                }, function(row) {
                    return row.reverse();
                });
                if (moved) this.afterMove();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var moved = this.move(function(row) {
                    return row.reverse();
                }, function(row) {
                    return row.reverse();
                }, function(row) {
                    return row;
                });
                if (moved) this.afterMove();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var moved = this.moveColumns(function(c) {
                    return c;
                }, function(c) {
                    return c.reverse();
                }, function(c) {
                    return c.reverse();
                });
                if (moved) this.afterMove();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var moved = this.moveColumns(function(c) {
                    return c.reverse();
                }, function(c) {
                    return c.reverse();
                }, function(c) {
                    return c;
                });
                if (moved) this.afterMove();
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.score = 0;
                this.status = "playing";
                this.board = this.createBoard();
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.start();
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var empty = [];
                for(var a = 0; a < this.size; a++){
                    for(var b = 0; b < this.size; b++)if (this.board[a][b] === 0) empty.push([
                        a,
                        b
                    ]);
                }
                if (empty.length === 0) return;
                var _empty_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(empty[Math.floor(Math.random() * empty.length)], 2), r = _empty_Math_floor[0], c = _empty_Math_floor[1];
                this.board[r][c] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "move",
            value: function move(transformIn, transformOut, restore) {
                var _this = this, _loop = function(r) {
                    var row = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.board[r]);
                    row = transformIn(row);
                    var merged = [];
                    var compact = row.filter(function(v) {
                        return v !== 0;
                    });
                    for(var i = 0; i < compact.length - 1; i++)if (compact[i] === compact[i + 1]) {
                        compact[i] *= 2;
                        _this.score += compact[i];
                        compact[i + 1] = 0;
                        merged.push(i);
                    }
                    var finalRow = compact.filter(function(v) {
                        return v !== 0;
                    });
                    while(finalRow.length < _this.size)finalRow.push(0);
                    var restored = restore(transformOut(finalRow));
                    if (restored.toString() !== _this.board[r].toString()) moved = true;
                    _this.board[r] = restored;
                };
                var moved = false;
                for(var r = 0; r < this.size; r++)_loop(r);
                return moved;
            }
        },
        {
            key: "moveColumns",
            value: function moveColumns(transformIn, transformOut, restore) {
                var _this = this, _loop = function(c) {
                    var col = [];
                    for(var r = 0; r < _this.size; r++){
                        col.push(_this.board[r][c]);
                        col = transformIn(col);
                    }
                    var compact = col.filter(function(v) {
                        return v !== 0;
                    });
                    for(var i = 0; i < compact.length - 1; i++)if (compact[i] === compact[i + 1]) {
                        compact[i] *= 2;
                        _this.score += compact[i];
                        compact[i + 1] = 0;
                    }
                    var finalCol = compact.filter(function(v) {
                        return v !== 0;
                    });
                    while(finalCol.length < _this.size)finalCol.push(0);
                    var restored = restore(transformOut(finalCol));
                    for(var r1 = 0; r1 < _this.size; r1++){
                        if (_this.board[r1][c] !== restored[r1]) moved = true;
                        _this.board[r1][c] = restored[r1];
                    }
                };
                var moved = false;
                for(var c = 0; c < this.size; c++)_loop(c);
                return moved;
            }
        },
        {
            key: "afterMove",
            value: function afterMove() {
                this.addRandomTile();
                this.checkStatus();
            }
        },
        {
            key: "checkStatus",
            value: function checkStatus() {
                if (this.board.flat().includes(2048)) {
                    this.status = "win";
                    return;
                }
                if (this.board.flat().includes(0)) {
                    this.status = "playing";
                    return;
                }
                for(var r = 0; r < this.size; r++)for(var c = 0; c < this.size; c++){
                    var val = this.board[r][c];
                    if (r < this.size - 1 && val === this.board[r + 1][c] || c < this.size - 1 && val === this.board[r][c + 1]) {
                        this.status = "playing";
                        return;
                    }
                }
                this.status = "lose";
            }
        }
    ]);
    return Game;
}();
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$startButton = document.querySelector(".button");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
function $197cd56b15c33885$var$renderBoard() {
    var state = $197cd56b15c33885$var$game.getState();
    var index = 0;
    for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
        var value = state[r][c];
        var cell = $197cd56b15c33885$var$cells[index];
        index++;
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add("field-cell--".concat(value));
    }
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
    // повідомлення
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    else if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
}
function $197cd56b15c33885$var$handleMove(direction) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(direction){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$renderBoard();
    if ($197cd56b15c33885$var$startButton.classList.contains("start")) {
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
        $197cd56b15c33885$var$startButton.textContent = "Restart";
    }
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$renderBoard();
    $197cd56b15c33885$var$startButton.classList.remove("start");
    $197cd56b15c33885$var$startButton.classList.add("restart");
    $197cd56b15c33885$var$startButton.textContent = "Restart";
});
document.addEventListener("keydown", function(e) {
    return $197cd56b15c33885$var$handleMove(e.key);
});
$197cd56b15c33885$var$renderBoard();

})();
//# sourceMappingURL=index.993c25f2.js.map
